import React, { useState, useEffect } from "react";
import { PulseButton, PulseTextField } from "@pulselabs-ai/shared-fe-ui";
import "./AddProjectModal.scss";

interface AddProjectModalProps {
  onClose: () => void;
  onSubmit: (projectData: { title: string; description: string }) => void;
  isEditMode?: boolean;
  initialData?: {
    title: string;
    description: string;
  };
}

const AddProjectModal: React.FC<AddProjectModalProps> = ({
  onClose,
  onSubmit,
  isEditMode = false,
  initialData,
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (isEditMode && initialData) {
      setTitle(initialData.title);
      setDescription(initialData.description);
    } else {
      // Clear form when opening for new project
      setTitle("");
      setDescription("");
    }
  }, [isEditMode, initialData]);

  const handleSubmit = () => {
    if (!title.trim()) return;
    onSubmit({ title, description });
    onClose();
  };

  const isValid =
    title.trim() &&
    description.trim() &&
    title.length <= 20 &&
    description.length <= 80;

  return (
    <div className="add-project-modal">
      <h1 className="pl-heading-xl">
        {isEditMode ? "Edit app details" : "Add an app"}
      </h1>
      {/* {!isEditMode && (
        <div>
          Your project should map directly to the product our SDK will be
          installed on. It will curate all the data you capture and have a
          unique API key.
        </div>
      )} */}
      <h2 className="pl-heading-xs-extra-bold">App details</h2>

      <div className="form-content">
        <div className="input-group">
          <PulseTextField
            label="App name"
            isHideIcon={true}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter app name"
            helperText={`${title.length}/20 characters maximum`}
            error={title.length > 20}
          />
        </div>

        <div className="input-group">
          <PulseTextField
            label="Objective"
            isHideIcon={true}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter app description"
            helperText={`${description.length}/80 characters maximum`}
            error={description.length > 80}
            multiline
            rows={2}
          />
        </div>
      </div>

      <div className="modal-actions" style={{ marginTop: "auto" }}>
        <PulseButton onClick={handleSubmit} disabled={!isValid}>
          {isEditMode ? "SAVE" : "ADD APP"}
        </PulseButton>
      </div>
    </div>
  );
};

export default AddProjectModal;
